import { getInitialSearchQueries } from 'modules/workflowNodeEditors/components/startNode/utils';

import { FilterSegmentSelectInputOption } from '../../FilterInputsList';
import { Query } from '../../FilterInputsList/FilterInputsList.types';
import { DEFAULT_SEARCH_QUERY } from '../constants';
import {
  ChildRule as ChildRuleType,
  EventAndSearchQueryValidationErrors,
  EventChildRule,
} from '../types';
import { EventOccursRule } from './EventOccursRule';
import { PropertyChangedRule } from './PropertyChangedRule';

interface CommonProps {
  searchQueries: Partial<Query>[];
  childRule: ChildRuleType;
  combinator: string;
  isUserPropertyType: boolean;
  isMaxOneRule?: boolean;
  isDisabled?: boolean;
  isJourneyConversionMetRule?: boolean;
}

type ConditionalProps =
  | {
      setCombinator?: never;
      childRuleErrors?: never;
      onSearchQueriesUpdate?: never;
      handleEventSelect?: never;
    }
  | {
      setCombinator: (combinator: string) => void;
      childRuleErrors?: EventAndSearchQueryValidationErrors;
      onSearchQueriesUpdate: (newQueries: Partial<Query>[]) => void;
      handleEventSelect: (selectedOptions: FilterSegmentSelectInputOption[]) => void;
    };

type ChildRuleProps = CommonProps & ConditionalProps;

export const ChildRule = ({
  searchQueries,
  onSearchQueriesUpdate,
  handleEventSelect,
  childRule,
  combinator,
  setCombinator,
  childRuleErrors,
  isUserPropertyType,
  isDisabled = false,
  isMaxOneRule = false,
  isJourneyConversionMetRule = false,
}: ChildRuleProps) => {
  return isUserPropertyType ? (
    <PropertyChangedRule
      initialQueries={getInitialSearchQueries(childRule.searchQuery?.searchQueries) as Query[]}
      query={searchQueries[0] || DEFAULT_SEARCH_QUERY}
      onSearchQueriesUpdate={onSearchQueriesUpdate}
      errors={childRuleErrors}
      isDisabled={isDisabled}
    />
  ) : (
    <EventOccursRule
      initialQueries={getInitialSearchQueries(childRule.searchQuery?.searchQueries) as Query[]}
      queries={searchQueries}
      onSearchQueriesUpdate={onSearchQueriesUpdate}
      onEventSelect={handleEventSelect}
      eventName={(childRule as EventChildRule).eventName}
      combinator={combinator}
      setCombinator={setCombinator}
      errors={childRuleErrors}
      isDisabled={isDisabled}
      isMaxOneRule={isMaxOneRule}
      isJourneyConversionMetRule={isJourneyConversionMetRule}
    />
  );
};
